module.exports = __webpack_public_path__ + "img/cbr-start.cd051ad2.svg";